import Tile from "components/Tile";
import styled from "styled-components";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import FlexContainer from "components/FlexContainer";
import virtualTourImg from "./images/virtual-tour.png";
import demandTaskingImg from "./images/demand-tasking.png";
import TooltipIconButton from "components/TooltipIconButton";
import { AddCircleOutline, ArrowBack } from "@mui/icons-material";
import SidebarHeader from "components/Sidebar/layout/SidebarHeader";

const Title = styled.h2`
  color: white;
  margin-bottom: 30px;
`;

const MainTile = styled.div`
  background-image: linear-gradient(180deg, rgba(47, 47, 47, 0) 0%, rgba(37, 34, 34, 0.87) 98.96%), url(${(props) => props.img});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-end;
  height: 16rem;
  font-size: ${({ theme }) => theme.font.size.text.small};
  margin: 1rem 0;
  padding: 1.25rem;
  border-radius: ${({ theme }) => theme.borderRadius.default};
  transition: background 0.35s;
  &:nth-of-type(odd) {
    margin-right: 2rem;
  }
  &:hover {
    cursor: pointer;
    // background: ${({ theme }) => theme.backgroundColor.tile.hover};
    background-image: linear-gradient(180deg, rgba(47, 47, 47, 0) 0%, rgb(10, 10, 10) 98.96%), url(${(props) => props.img});
  }
  
  strong {
    font-family: Roboto;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: #E5E5E5;
    margin: 0 0 0.25rem;
  }

  .category {
    font-family: "Open Sans";
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #C4C4C4;
  }
`;

const AddAssets = ({ types, onClose, onLocalUpload, onShowCollections, onIonAssets, onBack, onVirtualTour }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: 'TOGGLE_MAP_MODAL', show: true });
  }, [])

  return (
    <>
      <SidebarHeader onClose={onClose}>
        <TooltipIconButton title="Back" ariaLabel="back" placement="bottom" onClick={onBack} size={44}>
          <ArrowBack />
        </TooltipIconButton>
      </SidebarHeader>
      <Title>Add Assets</Title>
      <MainTile img={virtualTourImg}>
        <strong>Virtual Tour</strong>
        <p className="category">Add a 360 Tour from Matterport</p>
        <TooltipIconButton title="Add Tour" ariaLabel="add-tour" placement="top" size={44} position="true" right={1} bottom={-1} onClick={() => onVirtualTour({ id: 6, label: 'Virtual Tour' })}>
          <AddCircleOutline />
        </TooltipIconButton>
      </MainTile>
      <FlexContainer>
        {types.slice(0, types.length - 1).map(type => (
          <Tile title={type.label} onAdd={() => onLocalUpload(type)} bg={type.bg} key={type.id}>
            <p className="category">Add Data</p>
          </Tile>
        ))}
      </FlexContainer>
      <MainTile img={demandTaskingImg}>
        <strong>Points, Lines & Polygons</strong>
        <p className="category">Add KML, KMZ, and GeoJSON files</p>
        <TooltipIconButton title="Add Files" ariaLabel="add-files" placement="top" size={44} position="true" right={1} bottom={-1}
          onClick={() => onLocalUpload(types[types.length - 1])}>
          <AddCircleOutline />
        </TooltipIconButton>
      </MainTile>
    </>
  );
};

export default AddAssets;